/**
 * ดูตัวอย่าง widget ตัวจริงจากหน้ารายการ
 *
 * ต่างจาก TemplatePreview ที่เป็นภาพจำลอง layout — ตัวนี้ฝังหน้า
 * /v1/public/widget/{key}/preview ซึ่งรัน widget.js ตัวจริงกับบทความจริงและ
 * config จริงของ widget นั้น
 *
 * ใช้ endpoint preview-url แทนที่จะประกอบ URL เองในหน้าบ้าน เพราะ base URL ของ
 * API อาจไม่ใช่โดเมนเดียวกับหลังบ้าน (ดู config.urls.api) — ให้เซิร์ฟเวอร์บอกมา
 * ที่เดียวจะไม่หลุดเวลาเปลี่ยนโดเมน และเป็นวิธีเดียวกับที่หน้า builder ใช้อยู่แล้ว
 */
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../../lib/api.js';
import { Button, Badge } from '../../components/ui/index.js';
import { PagePreviewModal } from '../../components/PagePreviewModal.js';
import type { Widget } from '../../lib/queries.js';

export function WidgetLivePreviewModal({
  widget, onClose,
}: {
  widget: Widget | null;
  onClose: () => void;
}) {
  const previewUrl = useQuery({
    queryKey: ['widget-preview-url', widget?.id],
    queryFn: () => api
      .get<{ data: { url: string } }>(`/v1/widgets/${widget!.id}/preview-url`)
      .then((r) => r.data.url),
    enabled: Boolean(widget),
  });

  return (
    <PagePreviewModal
      open={Boolean(widget)}
      onClose={onClose}
      title={widget ? `ตัวอย่าง — ${widget.name}` : ''}
      url={previewUrl.data ?? null}
      unavailable={previewUrl.error ? 'โหลดตัวอย่างไม่สำเร็จ — ปิดแล้วลองใหม่อีกครั้ง' : undefined}
      meta={widget && (
        <>
          <Badge tone="gray">{widget.templateCode}</Badge>
          <span className="font-mono text-[11px] text-[var(--ink-3)]">{widget.publicKey}</span>
        </>
      )}
      footerExtra={widget && (
        <Link to={`/widgets/${widget.id}`}><Button variant="secondary">ไปตั้งค่า</Button></Link>
      )}
    />
  );
}
